import {getElementFromSessionStorage, setElementToSessionStorage} from 'app/helpers/webStorageUtility';
import Video from 'app/components/tv/models/video';

export const DEFAULT_AD_CREDITS = 80;
const STORAGE_KEY = 'adCredits';

export const updateAdCredits = (video: Video, playedTimeRanges: TimeRanges, adCreditsRef: any): void => {
  const playedTime = video.getPlayedTime(playedTimeRanges);
  adCreditsRef.current -= playedTime;
};

export const setAdCredits = (adCreditsRef: any, credits: number = DEFAULT_AD_CREDITS): void => {
  adCreditsRef.current = credits;
};

export const getAdCreditsFromSessionStorage = (): number => {
  const adCreditsFromStorage = getElementFromSessionStorage(STORAGE_KEY);
  return Number(adCreditsFromStorage);
};

export const setAdCreditsToSessionStorage = (adCredits: number): void => {
  setElementToSessionStorage(STORAGE_KEY, String(adCredits));
};
